import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";

import { AuthService } from "../services/auth.service";
import { Logger } from "src/app/core/logger/logger.service";

@Injectable()
export class AuthGuardLogged implements CanActivate {
  log = new Logger("AuthGuardLogged");

  constructor(private router: Router) { }

  canActivate(): boolean | UrlTree {
    const token = localStorage.getItem("jwt");
    const now = Math.floor(new Date().getTime() / 1000);
    this.log.debug(token);
    if (token) {
      const expire = AuthService.jwtDecode(token);
      if (expire.exp > now) {
        this.log.debug("Valid token");
        return this.router.createUrlTree(["/dashboard"]);
      } else {
        this.log.debug("Expired token ", token);
        localStorage.removeItem("token");
        localStorage.removeItem("jwt");
        return true;            // allow to go to login
      }
    } else {
      return true;            // allow to go to login
    }
  }
}
